module.exports = __webpack_public_path__ + "img/muyin.45a62dbe.png";